export function isProject(format?: {termId: string}[]): boolean {
  return process.env.GATSBY_PROJECTS_TERM_ID &&
    (format?.find((element) => element.termId === process.env.GATSBY_PROJECTS_TERM_ID) ? true : false) || false;
}
